<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" @selectField="onSelectField" />

    <!-- 목표 및 실적 -->
    <write-grid-container title="목표 및 실적" v-model="form.subInfo" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <vs-select v-if="dataType === 'selector'" class="w-full" autocomplete v-model="form.subInfo[value]">
            <vs-select-item v-for="item in ['목표', '실접']" :text="item" :value="item" :key="item" />
          </vs-select>
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter type="number" :defaultValue="header.year" :min-value="1900" :max-value="2100" />
        </div>
      </template>
    </write-grid-container>
    <div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>목표</div>
          <div v-if="isPrint" class="print-input" v-html="form.subInfo.목표"></div>
          <quill-editor v-else class="vx-col flex-1 ql-edit-text" v-model="form.subInfo.목표" :options="quillOption"></quill-editor>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
    quillEditor,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {},
  data() {
    return {
      quillOption: {
        placeholder: "내용을 입력해주세요",
      },
      form: {
        stdInfo: {},
        subInfo: {},
        photoList: [],
        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["year"],
        labels: ["대상년도"],
        values: ["대상년도"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  mounted() {},
  methods: {
    onSelectField() {
      // 인천 955 / 당진 953 / 포항 954 => 안전환경팀
      // 중앙기술 956 => 연구지원팀 101
      const vComName = this.form.stdInfo.virtual_company.com_name;
      const 사업장ID = this.form && this.form.stdInfo ? this.form.stdInfo.field_id : null;
      const 제한사업장 = [955, 953, 954, 956];

      // 제한사업장이 아닌 경우 저장 활성화
      if (!제한사업장.includes(사업장ID)) {
        this.$emit("EnableSave", true);
        return;
      }

      // 제한사업장인 경우, 각 사업장별 안전관리팀만 저장 활성화
      // virtual company
      // 8 : 안전환경기획팀
      // 53 : 안전환경 (인천)
      // 65 : 포항
      // 78 : 당진
      // 101 : 연구지원팀(생)
      let isEnable = false;
      if (사업장ID === 955 && vComName === "안전환경팀(인천)") {
        isEnable = true;
      } else if (사업장ID === 953 && vComName === "안전환경팀(당진)") {
        isEnable = true;
      } else if (사업장ID === 954 && vComName === "안전환경팀(포항)") {
        isEnable = true;
      } else if (사업장ID === 956 && vComName.startsWith("연구지원팀")) {
        isEnable = true;
      } else if (vComName === "안전환경기획팀") {
        isEnable = true;
      }

      this.$emit("EnableSave", isEnable);
    },
  },
};
</script>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}
</style>
